import { Grid, Typography } from '@material-ui/core'
import {
  Datagrid,
  DeleteWithConfirmButton,
  Filter,
  List,
  SaveButton,
  SearchInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  useTranslate,
  useRecordContext,
} from 'react-admin'
import { DialogForm } from '../components/DialogForm'

const SaveOnlyToolbar = (props) => {
  const record = useRecordContext()
  return (
    <Toolbar {...props}>
      <SaveButton {...props} />
      <DeleteWithConfirmButton
        variant="contained"
        color="error"
        size="medium"
        confirmContent="hs.compliance.janitor.delete_message"
        translateOptions={{ copro_code: record.copro_code }}
        style={{ marginLeft: '16px' }}
      />
    </Toolbar>
  )
}

export const JanitorEditDialog = () => {
  const record = useRecordContext()
  const translate = useTranslate()
  if (!record) return null

  return (
    <DialogForm
      title={translate('hs.compliance.janitor.title', {
        copro_code: record.copro_code,
      })}
      id={record.id}
    >
      <SimpleForm
        toolbar={<SaveOnlyToolbar />}
        resource="compliance/bank_account"
        basePath="/"
      >
        <Grid container item xs={12} spacing={3} fullWidth>
          <TextInput
            fullWidth
            disabled={true}
            source="copro_code"
            style={{ display: 'none' }}
          />
          <Grid item xs={6}>
            <TextInput fullWidth source="janitor_1_name" />
            <TextInput fullWidth source="janitor_1_email" />
            <TextInput fullWidth source="janitor_1_phone" />
          </Grid>
          <Grid item xs={6}>
            <TextInput fullWidth source="janitor_2_name" />
            <TextInput fullWidth source="janitor_2_email" />
            <TextInput fullWidth source="janitor_2_phone" />
          </Grid>
        </Grid>
      </SimpleForm>
    </DialogForm>
  )
}

const JanitorListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="copro_code" />
  </Filter>
)

const BooleanField = ({ source }) => {
  const record = useRecordContext()
  const transalte = useTranslate()
  if (!record) return null

  return (
    <Typography>
      {transalte(
        record[source] === true || record[source] === 'Oui' ? 'hs.yes' : 'hs.no'
      )}
    </Typography>
  )
}

export const JanitorList = (props) => (
  <List
    {...props}
    exporter={false}
    hasCreate={false}
    perPage={100}
    filters={<JanitorListFilter />}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="copro_code" />
      <BooleanField source="has_janitor" />
      <TextField source="janitor_1_name" />
      <TextField source="janitor_1_email" />
      <TextField source="janitor_1_phone" />
      <TextField source="janitor_2_name" />
      <TextField source="janitor_2_email" />
      <TextField source="janitor_2_phone" />
      <JanitorEditDialog {...props} />
    </Datagrid>
  </List>
)
